module.exports = __webpack_public_path__ + "0eC6fl06luXEYWpBSJvXCIX0hVgzZQUfRDuZrPvH3D8.8c04242ea119d74bd0d0.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/0eC6fl06luXEYWpBSJvXCIX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = ../../../../../src/assets/fonts/font-google/0eC6fl06luXEYWpBSJvXCIX0hVgzZQUfRDuZrPvH3D8.woff2
// module chunks = 40